import { render, staticRenderFns } from "./userRule.vue?vue&type=template&id=ba2eb3ca&scoped=true"
import script from "./userRule.vue?vue&type=script&lang=js"
export * from "./userRule.vue?vue&type=script&lang=js"
import style0 from "./userRule.vue?vue&type=style&index=0&id=ba2eb3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2eb3ca",
  null
  
)

export default component.exports